<template>
  <div class="contentsNone"><p>{{noneText}}</p></div>
</template>

<script>
export default {
  name: 'ContentsNone',
  components: {
  },
  props: {
    noneText: {
      type: String,
			default: ''
    }
  },
  data() {
    return {
    }
  },
  methods: {
  },
}
</script>

<style lang="scss">
.contentsNone {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  padding: 50px 0;
  background-color: #f7f7f7;
  z-index: 10;
  p {
    position: absolute;
    top: 50%;
    left: 0;
    width: 100%;
    height: 140px;
    padding: 0 16px;
    margin-top: -70px;
    text-align: center;
    font-size: 15px;
    overflow: hidden;
    &::before {
      content: '';
      display: block;
      width: 100%;
      height: 37px;
      margin-top: 32px;
      margin-bottom: 13px;
      background: url(../../assets/images/set_none.png) no-repeat center -150px;
      background-size: 50px;
    }
  }
}
.cart .contentsNone ::before {
  height: 43px;
  margin-top: 7px;
  background-position: center 0;
}
.recent .contentsNone ::before {
  height: 33px;
  margin-top: 17px;
  background-position: center -50px;
}
.coupon .contentsNone ::before {
  height: 29px;
  margin-top: 21px;
  background-position: center -100px;
}
.history .contentsNone ::before{
  height: 37px;
  margin-top: 13px;
  background-position: center -150px;
}
.search .contentsNone ::before {
  height: 40px;
  margin-top: 10px;
  background-position: center -200px;
}
</style>

